import * as React from 'react'

const QUOTED_TEXT = /"([^"]+)"/

/**
 * Renders a notification description, emphasising "quoted" names and keeping line breaks.
 * Built from React elements (never raw HTML) because descriptions embed user-controlled
 * names such as service providers and assessment titles.
 */
export const NotificationDescription = ({ text }: { text: string }) => (
  <>
    {text.split('\n').map((line, lineIndex) => (
      <span key={lineIndex}>
        {/* split() with a capture group puts the quoted text at the odd indices */}
        {line.split(QUOTED_TEXT).map((part, partIndex) =>
          partIndex % 2 === 1 ? (
            <React.Fragment key={partIndex}>
              "<b className='font-semibold text-foreground/75'>{part}</b>"
            </React.Fragment>
          ) : (
            part
          )
        )}
      </span>
    ))}
  </>
)
